import { Modal } from "flowbite-react";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";

function BuyerPersonaModal({ open, removeModal, knowLedgeBaseList }) {
  const { knowLedgeBaseListGlobal } = useContext(UserContext);
  const navigate = useNavigate();
  return (
    <div>
      <Modal
        show={open === "dismissible"}
        size="lg"
        onClose={() => removeModal()}
        zIndex="1000"
      >
        <Modal.Body className="p-0 rounded-[8px]">
          <div className="flex justify-center items-center bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] py-3">
            <svg className="icon text-[white] text-[50px]">
              <use href="#icon_info"></use>
            </svg>
          </div>
          <div className="p-4 py-8">
            <h3 className="text-center font-bold text-[26px]">
              {knowLedgeBaseListGlobal?.length > 0
                ? `Approval Required`
                : "No Knowledge base"}
            </h3>
            <p className="text-center font-bold text-[20px] text-[#7D7D7D]">
              {knowLedgeBaseListGlobal?.length > 0
                ? "Please approve Business Info & Buyer Persona"
                : "Please create a knowledge base either using your website or uploading business documents."}
            </p>
            <div className="pt-4 flex justify-center">
              <button
                type="button"
                className="flex w-[180px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white hover:opacity-90 transition"
                onClick={() => {
                  removeModal();
                  navigate("/knowledge");
                }}
              >
                {knowLedgeBaseListGlobal?.length > 0
                  ? "Review & Approve"
                  : "Create"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default BuyerPersonaModal;
